import { defineComponent } from 'vue';
import DateStart from '@/presentation/components/campaign-settings/date-start/date-start.vue';
import DateEnd from '@/presentation/components/campaign-settings/date-end/date-end.vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import DurationCode from '@/presentation/components/campaign-settings/duration/duration.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		DateStart,
		DateEnd
	},
	setup: () => {
		const code = new DurationCode();

		return {
			isLoading: code.isLoading,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldValidatedAndInvalid: code.isFieldValidatedAndInvalid,
			validationInfoDates: code.validationInfoDates,
			datesDisabledMessage: code.datesDisabledMessage
		};
	}
});
